@let texts = resourcesService.languageFile.value();

@if (useNavigatorShare()) {
  <div>
    <p-button (onClick)="navigatorShare()">{{ texts.shareScore }}</p-button>
  </div>
} @else {
  <gis-panel
    [isOverlay]="true"
    [buttonLabel]="texts.shareScore"
    [buttonStyle]="{padding: '8px 32px'}" panelWidth="400px">
    <div class="share-container">
      <div class="share-buttons">
        @for (app of shareApps(); track $index) {
          <span>
            <a [href]="app.url" [class]="app.name"
               target="_blank" (click)="closeShareButtonsPanel()">
              <span>{{ app.name | titlecase }}</span>
            </a>
          </span>
        }
        <span>
          <p-button class="to-clipboard" [text]="true"
                    (onClick)="copyToClipboard()">
            <span class="copy-to-clipboard-label">{{ texts.copyToClipboard }}</span>
          </p-button>
        </span>
        <span>
          @if (hasNavigatorShare()) {
            <p-button class="more" [text]="true"
                      (onClick)="navigatorShare()">{{ texts.more }} ...
            </p-button>
          }
        </span>
      </div>
    </div>
  </gis-panel>
}
